{
  "common.close": "বন্ধ করুন",
  "common.athleteFallback": "অ্যাথলিট {id}",
  "splash.title": "{app} — কার্যকলাপের অ্যানিমেটেড চিত্র",
  "splash.tagline": "আপনার&nbsp;Strava ডেটার চলমান মানচিত্র",
  "splash.demo": "ডেমো",
  "tab.query.title": "{name}-এর মানচিত্র",
  "tab.query.heading": "কার্যকলাপ খুঁজুন:",
  "tab.query.optDays": "সাম্প্রতিক দিন",
  "tab.query.optActivities": "সাম্প্রতিক কার্যকলাপ",
  "tab.query.optIds": "কার্যকলাপের আইডি",
  "tab.query.optDates": "তারিখের পরিসর",
  "tab.query.idsPlaceholder": "এখানে কার্যকলাপের আইডি লিখুন",
  "tab.query.after": "পরে:",
  "tab.query.before": "আগে:",
  "tab.query.autozoom": "ইম্পোর্টের পর ফলাফলে স্বয়ংক্রিয় জুম <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> খুঁজুন",
  "tab.query.createAccount": "অ্যাকাউন্ট খুলুন এবং/অথবা লগ ইন করুন।",
  "tab.query.sports": "খেলা:",
  "tab.query.allSports": "সব খেলা",
  "tab.query.sportsExcept": "সব, এগুলো ছাড়া",
  "tab.query.sportsNone": "কোনোটিই নয়",
  "tab.query.loadingSports": "খেলা লোড হচ্ছে…",
  "tab.query.sportsFailed": "এই মানচিত্রের খেলা লোড করা যায়নি",
  "tab.query.noSports": "এখনও কোনো কার্যকলাপ নেই",
  "tab.activities.title": "প্রদর্শিত কার্যকলাপ",
  "tab.activities.clearSelection": "নির্বাচন মুছুন",
  "tab.activities.renderSelected": "নির্বাচিতগুলো দেখান",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> নির্বাচনে জুম করুন",
  "tab.controls.title": "লেয়ার সেটিংস",
  "tab.controls.timescale": "সময়-মাপ <i>&tau;</i>",
  "tab.controls.timescaleHint": "চালানোর গতি",
  "tab.controls.period": "পর্যায়কাল <i>T</i>",
  "tab.controls.periodHint": "কার্যকলাপ ~ মডেল",
  "tab.controls.dotSize": "বিন্দুর আকার",
  "tab.controls.pathWidth": "পথের প্রস্থ",
  "tab.controls.pathWidthHint": "শূন্য দিলে পথ লুকায়",
  "tab.controls.colors": "রং",
  "tab.controls.colorsHint": "রঙের প্যালেট ঘোরান",
  "tab.controls.shadows": "ছায়া",
  "tab.profile.loginTitle": "লগ ইন",
  "tab.profile.anonNote": "নিজের কার্যকলাপ দেখতে এবং আপনার Heatflask অ্যাকাউন্ট পরিচালনা করতে Strava দিয়ে লগ ইন করুন।",
  "tab.profile.loginLink": "Strava দিয়ে লগ ইন করুন",
  "tab.profile.editOnStrava": "Strava-তে আপনার প্রোফাইল সম্পাদনা করুন",
  "tab.profile.indexNote": "দ্রুত দেখার জন্য আমরা আপনার কার্যকলাপের সারসংক্ষেপ সূচিবদ্ধ করি।",
  "tab.profile.viewIndex": "সূচি দেখুন",
  "tab.profile.sharedMaps": "শেয়ার করা মানচিত্র",
  "tab.profile.sharedMapsNote": "বন্ধ: Heatflask-এ আপনার কার্যকলাপ শুধু আপনিই দেখতে পান। চালু: আপনার মানচিত্রের লিংক যার কাছে আছে, সে Strava-তে আপনার সর্বজনীন করা কার্যকলাপ দেখতে পারবে। আপনার ব্যক্তিগত কার্যকলাপ দুই ক্ষেত্রেই আপনারই থাকে। <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">গোপনীয়তা কীভাবে কাজ করে</a>",
  "tab.profile.logout": "লগ আউট",
  "tab.profile.deleteAccount": "অ্যাকাউন্ট মুছুন",
  "tab.profile.deleteConfirm": "আপনার Heatflask অ্যাকাউন্ট মুছবেন?\n\nএতে আপনার সূচিবদ্ধ কার্যকলাপ মুছে যাবে এবং আপনার Strava ডেটায় Heatflask-এর প্রবেশাধিকার বাতিল হবে। এটি আর ফেরানো যাবে না।",
  "tab.profile.languageHeading": "ভাষা",
  "tab.profile.languageAuto": "স্বয়ংক্রিয়",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">অনুবাদ ঠিক করতে বা নতুন যোগ করতে আমাদের সাহায্য করুন!</a>",
  "tab.profile.unitsHeading": "একক",
  "tab.profile.unitsAuto": "স্বয়ংক্রিয়",
  "tab.profile.unitsMetric": "মেট্রিক (কিমি, মি)",
  "tab.profile.unitsImperial": "ইম্পেরিয়াল (মাইল, ফুট)",
  "tab.profile.textSizeHeading": "লেখার আকার",
  "tab.profile.textSmaller": "ছোট",
  "tab.profile.textReset": "স্বাভাবিক",
  "tab.profile.textLarger": "বড়",
  "tab.profile.mapDefaultsHeading": "মানচিত্রের ডিফল্ট",
  "tab.profile.mapDefaultsNote": "যে মানচিত্রের লিংক নিজের সেটিংস ঠিক করে না, তেমন মানচিত্র খুললেই এই বেসম্যাপ, ভূ-প্রকৃতি ও লেয়ার সেটিংস দিয়ে শুরু করুন। আপনার শেয়ার করা লিংক তবুও ঠিক আপনি যা দেখেন তা-ই দেখায়।",
  "tab.profile.mapDefaultsSave": "আমার ডিফল্ট হিসেবে সংরক্ষণ করুন",
  "tab.profile.mapDefaultsForget": "ভুলে যান",
  "tab.info.title": "তথ্য",
  "tab.info.controlsHeading": "নিয়ন্ত্রণ",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + টানুন",
  "tab.info.shiftDragDesc": "একটি বাক্সের মধ্যে কার্যকলাপ বাছুন। টাচস্ক্রিনে আগে <i class=\"hf-object-group\"></i> চাপুন, তারপর এক আঙুলে টানুন। শেষ নির্বাচিত কার্যকলাপের বিবরণ দেখা যায়, আর কার্যকলাপের তালিকা সেখানে স্ক্রল করে যায়।",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + টানুন",
  "tab.info.ctrlDragDesc": "মানচিত্র 3D-তে ঘোরান ও কাত করুন, অথবা দুই আঙুল ব্যবহার করুন",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "সাইডবার খুলুন বা বন্ধ করুন",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "আগের বা পরের সাইডবার ট্যাব",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "সাইডবার বন্ধ করুন",
  "tab.info.liveUrlHeading": "লাইভ URL",
  "tab.info.liveUrlDesc": "মানচিত্রের দৃশ্য ও অ্যানিমেশনের সেটিংস পেজের URL-এ থাকে, তাই যার সঙ্গে শেয়ার করবেন সে একই দৃশ্য দেখবে।",
  "tab.info.videoHeading": "ভিডিও এক্সপোর্ট",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> বোতামটি অ্যানিমেশনকে MP4 হিসেবে রেকর্ড করে: এটি চাপুন, মানচিত্রের যে অংশ চান তার ওপর বাক্সটি বসান, তারপর রেকর্ড করতে আবার চাপুন। অ্যানিমেশনের একটি পূর্ণ চক্র রেকর্ড হয়, তাই ভিডিওটি নিরবচ্ছিন্নভাবে পুনরাবৃত্ত হয়; {max} সেকেন্ডের (Strava যত দীর্ঘ ভিডিও নেয়) চেয়ে লম্বা চক্র {max}-এ কেটে দেওয়া হয়।",
  "tab.info.contributeHeading": "অবদান রাখুন",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub-এ সহায়তা করুন",
  "tab.info.contactsHeading": "যোগাযোগ",
  "map.basemapAndTerrain": "বেসম্যাপ ও ভূ-প্রকৃতি",
  "map.pauseAnimation": "অ্যানিমেশন থামান",
  "map.resumeAnimation": "অ্যানিমেশন চালু করুন",
  "capture.record": "ভিডিও রেকর্ড করুন ({period} সে. চক্র)",
  "capture.recordTruncated": "ভিডিও রেকর্ড করুন (একটি চক্র {period} সে.; শুধু প্রথম {max} সে. রেকর্ড হবে)",
  "capture.recordArea": "বাক্সের ভেতরের অংশ রেকর্ড করুন",
  "capture.stop": "রেকর্ডিং থামান",
  "capture.selectionTooSmall": "নির্বাচনটি খুব ছোট",
  "capture.saved": "{name} সংরক্ষিত ({size})",
  "capture.cancelled": "রেকর্ডিং বাতিল",
  "capture.failed": "রেকর্ডিং ব্যর্থ: {error}",
  "capture.loadingEncoder": "এনকোডার লোড হচ্ছে…",
  "capture.waitingForMap": "মানচিত্র লোডের অপেক্ষা…",
  "capture.encoding": "এনকোড হচ্ছে… {percent}%",
  "capture.finalizing": "শেষ করা হচ্ছে…",
  "share.title": "এই মানচিত্রের লিংক শেয়ার করুন",
  "share.copied": "লিংক কপি হয়েছে",
  "share.copiedUnshared": "লিংক কপি হয়েছে — কিন্তু আপনার মানচিত্র শেয়ার করা নেই, তাই অন্য কেউ এটি খুলতে পারবে না। বদলাতে “শেয়ার করা মানচিত্র” চালু করুন।",
  "share.unshared": "আপনার মানচিত্র শেয়ার করা নেই, তাই অন্য কেউ এই লিংক খুলতে পারবে না। বদলাতে “শেয়ার করা মানচিত্র” চালু করুন।",
  "share.copyThis": "এই লিংকটি কপি করুন:",
  "update.available": "Heatflask-এর একটি নতুন সংস্করণ পাওয়া যাচ্ছে।",
  "update.reload": "আবার লোড করুন",
  "import.title": "ইম্পোর্ট হচ্ছে",
  "import.stop": "থামান",
  "import.stopping": "থামছে…",
  "import.contacting": "Strava-র সঙ্গে যোগাযোগ হচ্ছে…",
  "import.countOf": "কার্যকলাপ: {total}-এর মধ্যে {received}",
  "import.count": "কার্যকলাপ: {received}",
  "import.waitStrava": "Strava-র ডাউনলোড সীমার কারণে {time} পর্যন্ত থেমে আছে। পেজটি খোলা রাখুন; রিলোড করলে দ্রুত হবে না।",
  "import.waitRationed": "আজকের দ্রুত ডাউনলোড শেষ। বাকিগুলো {time}-এ ধীরে চলবে। পেজটি খোলা রাখুন।",
  "import.dailyLimit": "Strava-র দৈনিক ডাউনলোড সীমা শেষ। {time}-এর পরে আবার চেষ্টা করুন।",
  "import.dailyRationed": "আজ Strava ডাউনলোডে আপনার ভাগ শেষ। {time}-এর পরে আবার চেষ্টা করুন।",
  "import.noActivitiesYet": "আপনার Strava অ্যাকাউন্টে এখনও কোনো অ্যাক্টিভিটি নেই। Strava-তে একটি রেকর্ড বা আপলোড করুন, তা এখানে দেখা যাবে।",
  "table.noActivities": "কোনো কার্যকলাপ নেই",
  "table.untitled": "(শিরোনামহীন)",
  "activities.pageTitle": "{app} — কার্যকলাপ সূচি",
  "activities.heading": "কার্যকলাপ সূচি",
  "activities.fetching": "কার্যকলাপ আনা হচ্ছে...",
  "activities.rateLimit": "Strava-র অনুরোধ-সীমা পূর্ণ; {time}-এ আবার শুরু হবে",
  "activities.noData": "দুঃখিত, কোনো ডেটা নেই &#128577;",
  "activities.colServerCache": "ট্র্যাক সার্ভারে সংরক্ষিত (Mongo)",
  "activities.colBrowserCache": "ট্র্যাক এই ব্রাউজারে সংরক্ষিত",
  "activities.cachedServer": "{id}-এর ট্র্যাক সার্ভারে সংরক্ষিত আছে",
  "activities.notCachedServer": "{id}-এর ট্র্যাক সার্ভারে সংরক্ষিত নেই",
  "activities.cachedBrowser": "{id}-এর ট্র্যাক এই ব্রাউজারে সংরক্ষিত আছে",
  "activities.notCachedBrowser": "{id}-এর ট্র্যাক এই ব্রাউজারে সংরক্ষিত নেই",
  "sport.AlpineSki": "আলপাইন স্কিইং",
  "sport.BackcountrySki": "ব্যাককান্ট্রি স্কিইং",
  "sport.Badminton": "ব্যাডমিন্টন",
  "sport.Basketball": "বাস্কেটবল",
  "sport.Canoeing": "ক্যানোয়িং",
  "sport.Cricket": "ক্রিকেট",
  "sport.Crossfit": "ক্রসফিট",
  "sport.Dance": "নাচ",
  "sport.EBikeRide": "ই-বাইক রাইড",
  "sport.Elliptical": "এলিপটিক্যাল",
  "sport.EMountainBikeRide": "ই-মাউন্টেন বাইক রাইড",
  "sport.Golf": "গলফ",
  "sport.GravelRide": "গ্রাভেল রাইড",
  "sport.Handcycle": "হ্যান্ডসাইকেল",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "হাইকিং",
  "sport.IceSkate": "আইস স্কেটিং",
  "sport.InlineSkate": "ইনলাইন স্কেটিং",
  "sport.Kayaking": "কায়াকিং",
  "sport.Kitesurf": "কাইটসার্ফিং",
  "sport.MountainBikeRide": "মাউন্টেন বাইক রাইড",
  "sport.NordicSki": "নর্ডিক স্কিইং",
  "sport.Padel": "প্যাডেল",
  "sport.PhysicalTherapy": "ফিজিওথেরাপি",
  "sport.Pickleball": "পিকলবল",
  "sport.Pilates": "পিলাটিস",
  "sport.Racquetball": "র‍্যাকেটবল",
  "sport.Ride": "সাইকেল রাইড",
  "sport.RockClimbing": "পাহাড় বেয়ে ওঠা",
  "sport.RollerSki": "রোলার স্কি",
  "sport.Rowing": "নৌকা বাওয়া",
  "sport.Run": "দৌড়",
  "sport.Sail": "পালতোলা নৌকা",
  "sport.Skateboard": "স্কেটবোর্ড",
  "sport.Snowboard": "স্নোবোর্ড",
  "sport.Snowshoe": "স্নোশু",
  "sport.Soccer": "ফুটবল",
  "sport.Squash": "স্কোয়াশ",
  "sport.StairStepper": "স্টেয়ার স্টেপার",
  "sport.StandUpPaddling": "স্ট্যান্ড আপ প্যাডলিং",
  "sport.Surfing": "সার্ফিং",
  "sport.Swim": "সাঁতার",
  "sport.TableTennis": "টেবিল টেনিস",
  "sport.Tennis": "টেনিস",
  "sport.TrailRun": "ট্রেইল রান",
  "sport.Velomobile": "ভেলোমোবাইল",
  "sport.VirtualRide": "ভার্চুয়াল রাইড",
  "sport.VirtualRow": "ভার্চুয়াল নৌকা বাওয়া",
  "sport.VirtualRun": "ভার্চুয়াল দৌড়",
  "sport.Volleyball": "ভলিবল",
  "sport.Walk": "হাঁটা",
  "sport.WeightTraining": "ওজন প্রশিক্ষণ",
  "sport.Wheelchair": "হুইলচেয়ার",
  "sport.Windsurf": "উইন্ডসার্ফিং",
  "sport.Workout": "ব্যায়াম",
  "sport.Yoga": "যোগব্যায়াম"
}
